'use strict';

var React = require('react');

module.exports = React.createClass({
	displayName: 'TeaserCaption',

	render: function() {
		var caption = this.props.children;

		if (!caption) {
			return false;
		}

		return (
			<h2 {...this.props}>
				{caption}
			</h2>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./app/components/Teaser/TeaserCaption.jsx
 **/